import React from "react";
import { Stack, Typography } from "@mui/material";
import HyroSingleSelect from "src/components/hyro-components/fields/single-option/HyroSingleSelect";
import { FILTER_OPERATORS } from "@hyro-components/hyro-filter/HyroFilter.consts";
import { filterSelectStyles, filterMenuStyles, filterMenuPaperStyles } from "./FilterFieldHeader.styles";

const FilterFieldHeader = ({ label, operator, onChange }) => {
  if (!operator) {
    return <Typography variant="inputText2" color="text.800">
      {label} contains:
    </Typography>;
  }

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Typography variant="inputText2" color="text.800">{label}:</Typography>

      <HyroSingleSelect
        testId="filter-operator-select"
        options={FILTER_OPERATORS.filter(op => !op.hideInMenu)}
        value={operator}
        onChange={newOperator => onChange(newOperator)}
        fullWidth={false}
        SelectProps={{
          sx: filterSelectStyles,
          MenuProps: {
            sx: filterMenuStyles,
            PaperProps: {
              style: filterMenuPaperStyles
            }
          }
        }}
      />
    </Stack>
  );
};

export default FilterFieldHeader;
